import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import {
  FormControl,
  FormHelperText,
  TextField,
  FormLabel,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import moment from "moment-timezone";
import { convertTime12to24 } from "../../helpers/convertTime12to24";
const timeFormat = "HH:mm";
const dateFormat = "YYYY-MM-DD";

class CompositeDateTimePickers extends React.Component {
  handleChange = (field) => (event) => {
    const { value } = event.target;
    const { timezone } = this.props;
    const updatedDatetime = moment(this.props.value).tz(timezone).set({
      seconds: 0,
      milliseconds: 0,
    });
    const now = moment();

    if (field === "time") {
      let hours = 0;
      let minutes = 0;
      if (value) {
        const timeParts = value.split(":");
        hours = timeParts[0];
        minutes = timeParts[1];
      }
      updatedDatetime.set({ hours, minutes });
    } else if (field === "date") {
      let year = now.year();
      let month = now.month();
      let date = now.date();
      if (value) {
        const dateParts = value.split("-");
        year = dateParts[0];
        month = parseInt(dateParts[1], 10) - 1;
        date = dateParts[2];
      }
      updatedDatetime.set({ year, month, date });
    }

    this.props.handleChange(updatedDatetime);
  };

  render() {
    const {
      classes,
      label,
      helperText,
      error,
      disableTime,
      value,
      disabled,
      timezone,
    } = this.props;
    const datetime = moment(value).tz(timezone);
    const date = datetime.format(dateFormat);
    const time = datetime.format(timeFormat);
    return (
      <FormControl error={error} className={classes.formControl} fullWidth>
        {label && (
          <FormLabel
            id={this.props.labelId}
            htmlFor={this.props.dateInputId}
            className={classes.label}
          >
            {label}
          </FormLabel>
        )}
        <Grid
          container
          spacing={2.5}
          direction="row"
          className={classes.fieldsRow}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              id={this.props.dateInputId}
              disabled={disabled}
              type="date"
              fullWidth
              value={date}
              onChange={this.handleChange("date")}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              id={this.props.timeInputId}
              type="time"
              disabled={disabled || disableTime}
              fullWidth
              value={convertTime12to24(time)}
              onChange={this.handleChange("time")}
            />
          </Grid>
        </Grid>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
}

CompositeDateTimePickers.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  disableTime: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabled: PropTypes.bool,
  labelId: PropTypes.string,
  dateInputId: PropTypes.string,
  timeInputId: PropTypes.string,
};

const styles = (theme) => ({
  label: {
    fontWeight: "bold",
    fontSize: "1rem",
    marginBottom: "5px",
    color: theme.palette.text.primary,
  },
  formControl: {
    margin: 0,
    width: "100%",
  },
  fieldsRow: {
    width: "100%",
    marginLeft: 0,
    marginRight: 0,
    alignItems: "flex-start",
    rowGap: "20px",
  },
});

export default withStyles(styles)(CompositeDateTimePickers);
